/* eslint-disable @typescript-eslint/naming-convention */
import { FormControl, FormErrorMessage, FormLabel, NumberInput, NumberInputField } from '@chakra-ui/react'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

export function ShirtNumberField() {
    const { newPlayer, takenShirtNumWithoutExistingPlayer = [], patchPlayer } = useAddPlayerContext()

    const isShirtNumberTaken =
        typeof newPlayer.shirt_number === 'number'
            ? takenShirtNumWithoutExistingPlayer.includes(newPlayer.shirt_number)
            : false

    const isShirtNumberTooHigh = Boolean(typeof newPlayer.shirt_number === 'number' && newPlayer.shirt_number > 99)

    const isInvalid = isShirtNumberTooHigh || isShirtNumberTaken

    const errorMessage = (() => {
        if (isShirtNumberTaken) {
            return <FormErrorMessage>Shirt number already taken</FormErrorMessage>
        }

        if (isShirtNumberTooHigh) {
            return <FormErrorMessage>Can't be higher than 99</FormErrorMessage>
        }

        return null
    })()

    return (
        <FormControl isInvalid={isInvalid}>
            <FormLabel>Shirt Number</FormLabel>
            <NumberInput
                className="player-shirt-number-input"
                min={0}
                max={99}
                value={newPlayer.shirt_number ?? ''}
                onChange={e => {
                    const numberValue = parseInt(String(e), 10)
                    patchPlayer({
                        shirt_number: !Number.isNaN(numberValue) && numberValue > 0 ? numberValue : undefined,
                    })
                }}>
                <NumberInputField placeholder="Shirt #" />
            </NumberInput>
            {errorMessage}
        </FormControl>
    )
}
